export default "__VITE_ASSET__DMXXukS7__"